<template>
    <b-modal
        id="rating-modal"
        ref="rating-modal"
        centered
        :hide-header-close="true"
        :cancel-disabled="true"
        :ok-disabled="true"
        size="md"
        header-bg-variant="info"
        no-close-on-backdrop
        no-close-on-esc
        hide-footer
        hide-backdrop
        hide-header
    >
        <div class="bg-white mt-1 text-center">
            <b-form-group
                id="fieldset-horizontal"
                label-cols="6"
                label-cols-md="6"
                :label="!sent?data.label:data.goodby"
                label-align-md="right"
                label-align="center"
                label-size="sm"
                label-for="input-horizontal"
                class="mb-0 pb-0"
            >
                <b-form-rating
                    id="input-horizontal"
                    v-model="rate"
                    icon-empty="star"
                    icon-half="star-half"
                    icon-full="star-fill"
                    variant="success"
                    size="sm"
                    no-border
                    class="bg-transparent m-0 p-0"
                    @change="send"
                    :readonly="sent"
                    :disabled="form_disabled"
                    :stars="data.stars"
                ></b-form-rating>
            </b-form-group>
        </div>
    </b-modal>
</template>
<script>

export default {
    name: 'Rating',
    data() {
        return {
            rate: 0,
            sent: false,
            form_disabled: false
        }
    },
    props: {
        data: { type: Object, default: () => ({}) },
        assistant: { type: Object, default: () => ({}) },
    },
    methods: {
        send(value) {
            this.form_disabled = true
            this.$store.dispatch(
                'post', 
                {
                    'url': '/catalog/ratings/public_rate', 
                    data: {
                        rating_key_id: this.data.key_id,
                        assistant_key_id: this.assistant.key_id,
                        rating_value: value
                    }, 
                    headers:{}
                })
                .then((resp) => {
                    this.form_disabled=false
                    this.sent = true
                    setTimeout(() => {  this.$emit('closeMe'); }, 5000);
                })
                .catch(err => {
                    this.form_disabled=false
                    setTimeout(() => {  this.$emit('closeMe'); }, 5000);
                })
        },
        showModal() {
            this.$bvModal.show('rating-modal')
        },
    },
    mounted() {
        this.showModal()
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../styles/app';
    
</style>